/**
 * 組織選擇器組件
 * 組織下拉選單和組織列表管理
 */

import * as React from "react";
import { Dropdown, Option, Label, makeStyles, tokens } from "@fluentui/react-components";
import { Building20Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  formGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    backgroundColor: tokens.colorNeutralBackground2,
    padding: "12px",
    borderRadius: "8px",
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    flexShrink: 0,
  },
  dropdown: {
    minWidth: "200px",
  },
  label: {
    fontWeight: "600",
    fontSize: "13px",
    color: tokens.colorNeutralForeground2,
  },
});

const ORG_OPTIONS = [
  { value: "K0", key: "K0" },
  { value: "K1", key: "K1" },
  { value: "KS", key: "KS" },
  { value: "KCQS", key: "KCQS" },
  { value: "KCXG", key: "KCXG" },
  { value: "KCHC", key: "KCHC" },
  { value: "KCKH", key: "KCKH" },
  { value: "NJ", key: "NJ" },
  { value: "KCCS", key: "KCCS" },
  { value: "KCEC", key: "KCEC" },
  { value: "KCHF", key: "KCHF" },
  { value: "KCTZ", key: "KCTZ" },
  { value: "KCXA", key: "KCXA" },
  { value: "DR01", key: "DR01" },
];

const OrgSelector = ({ selectedOrg, onOrgChange }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <div className={styles.formGroup}>
      <Label className={styles.label}>
        <Building20Regular style={{ marginRight: '6px', verticalAlign: 'middle' }} />
        {t('select_org')}
      </Label>
      <Dropdown
        className={styles.dropdown}
        value={selectedOrg ? t(`org_options.${selectedOrg}`) : t('org_options.KS')}
        selectedOptions={[selectedOrg || 'KS']}
        onOptionSelect={(e, data) => {
          if (data.optionValue) {
            onOrgChange(data.optionValue);
          }
        }}
      >
        {ORG_OPTIONS.map(org => (
          <Option key={org.key} value={org.value}>
            {t(`org_options.${org.value}`)}
          </Option>
        ))}
      </Dropdown>
    </div>
  );
};

export default OrgSelector;

